// Configuration for the frontend application
// You can toggle between local testing and production deployment here

// Production URL (Render) - Update this after deploying backend on Render
export const PROD_URL = 'https://rentafai-backend-1b9f588530c5.herokuapp.com/';

// Local Development URL
export const LOCAL_URL = 'http://localhost:5000';

// Current API Base URL
// Change this to LOCAL_URL when testing locally
export const API_BASE_URL = PROD_URL  || LOCAL_URL;

// Document Generation API (FastAPI backend - separate service)
export const DOCGEN_API_BASE_URL = process.env.REACT_APP_DOCGEN_API_URL || 'http://localhost:8000';

const config = {
  API_BASE_URL,
  PROD_URL,
  LOCAL_URL
};

export default config;

